import React, { FC, useCallback, useState, useEffect} from "react";
import { ComponentTypeID, IProjectFailureMode, IRiskAssessment } from "../types/types";
import { useTask } from '../stateManagement/context';
import {
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TableCell,
    TableRow,
    Typography
} from "@material-ui/core";
import FailureModesSelect from "./failure_mode";

import { Chat, Delete, Edit } from "@material-ui/icons";
import AddRiskAssessmentDialog from "./add_risk_assessment_dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";
import Comments from "./comments";

interface IRiskAssessmentProps {
    failure_modes: IProjectFailureMode[]
    risk_assessment: IRiskAssessment
    updateRiskAssessment: (risk_assessment: IRiskAssessment) => void;
}



const RiskAssessment: FC<IRiskAssessmentProps> = ({ failure_modes, risk_assessment, updateRiskAssessment }) => {

    const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()


    let initial_selection_id = ""
    if (risk_assessment.project_failure_mode) {
        if (risk_assessment.project_failure_mode.id) {
            initial_selection_id = risk_assessment.project_failure_mode.id.toString()
        }
    }

    const handleEdit = () => {
        setOpenAddDialog(true)
    }

    const addDialogCallback = useCallback(() => {
        setOpenAddDialog(false)

    }, [setOpenAddDialog]);

    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }

    const handleDelete = () => {

        let ra = { ...risk_assessment }
        ra.is_active = false
        updateRiskAssessment(ra)
        setAreYouSure(false)
    }

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const renderAreYouSure = () => {
        return (
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove  {risk_assessment.failure_mode}</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove failure mode <b>{risk_assessment.failure_mode}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (

        <>{renderAreYouSure()}
            {openAddDialog && <AddRiskAssessmentDialog risk_assessment={risk_assessment}
                updateRiskAssessmentCallback={updateRiskAssessment}
                closeDialogCallback={addDialogCallback} />}
            <TableRow>
                <TableCell>{risk_assessment.failure_mode}</TableCell>
                <TableCell>{risk_assessment.description}</TableCell>
                <TableCell align="right">{risk_assessment.annual_failure_probability?.toExponential(2)}</TableCell>
                <TableCell align="right">{risk_assessment.societal_risk?.toExponential(2)}</TableCell>
                <TableCell align="right">{risk_assessment.individual_risk?.toExponential(2)}</TableCell>
                <TableCell><FailureModesSelect failure_modes={failure_modes} risk_assessment={risk_assessment} updateRiskAssessment={updateRiskAssessment} initial_selection_id={initial_selection_id} /></TableCell>
                <TableCell>{risk_assessment.document?.name}</TableCell>
                <TableCell>{risk_assessment.uuid && <Comments parent_uuid={risk_assessment.uuid} type_id={ComponentTypeID.RiskAssessment} />}</TableCell>
                <TableCell>
                    {write_access &&
                        <>
                            <IconButton color="primary" aria-label="upload picture" component="span" style={{
                                color: "rgb(239,88,43)",

                            }} onClick={() => handleEdit()}>
                                <Edit />
                            </IconButton>

                            <IconButton color="primary" aria-label="upload picture" component="span" style={{
                                color: "rgb(239,88,43)",

                            }} onClick={() => setAreYouSure(true)} >
                                <Delete />
                            </IconButton>
                        </>
                    }
                </TableCell>
            </TableRow>
        </>
    );
}

export default RiskAssessment;
